var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import FooterContainer from './FooterContainer';
import { getCurrentUser } from '../localStorage';
import { useRequest } from '../hooks/requestHook';
import { roaster as api } from '../api';
var RoasterFooter = function () {
    var _a;
    var currentUser = getCurrentUser();
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var get = useRequest(api.get);
    var _c = React.useState(), roaster = _c[0], setRoaster = _c[1];
    React.useEffect(function () {
        if (currentUser.id === '0')
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, get(undefined)];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setRoaster(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [get, currentUser.id]);
    // roaster新規登録時はcountryが確定していないのでoptionalにする
    var isTaiwaneseRoaster = ((_a = roaster === null || roaster === void 0 ? void 0 : roaster.country) === null || _a === void 0 ? void 0 : _a.code) === 'TW';
    return (React.createElement(FooterContainer, { isTaiwaneseRoaster: isTaiwaneseRoaster },
        React.createElement("div", { className: "links" },
            React.createElement("a", { href: "https://typica.jp/app/roaster/privacy" }, t('links.privacy_policy')),
            ' | ',
            React.createElement("a", { href: "/cookie-policy" }, t('links.cookiePolicy')),
            ' | ',
            React.createElement("a", { href: "https://typica.jp/app/roaster/tokusyo/" }, t('links.specified_commercial_transactions_law')),
            ' | ',
            React.createElement("a", { href: "/term.html?role=roaster&locale=".concat(i18n.language), target: "_blank", rel: "noopener noreferrer" }, t('links.tos')))));
};
export default RoasterFooter;
